import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { DatePicker, Input, Select, Spin } from "antd";
import dayjs from "dayjs";

import { Api_Caller } from "../../utils/Api";
import AttendanceTable from "./components/AttendanceTable";
import AttendanceModal from "./components/AttendanceModal";

import "./attendance.css";

const { Search } = Input;

const Attendance = () => {
  const auth = useSelector((state) => state.auth || {});

  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("ALL");

  const [selectedAgent, setSelectedAgent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const getAttendance = async (date) => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${process.env.REACT_APP_API_ALL}/${Api_Caller.attendance}`,
        {
          params: {
            date: date.format("YYYY-MM-DD"),
            includeAbsent: true,
          },
          headers: {
            Authorization: `Bearer ${auth.accessToken}`,
          },
        },
      );

      setAttendance(response.data.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAttendance(selectedDate);
  }, [selectedDate]);

  const filteredAttendance = useMemo(() => {
    return attendance.filter((item) => {
      const keyword = search.toLowerCase();

      const matchesSearch =
        item.name?.toLowerCase().includes(keyword) ||
        item.employeeId?.toLowerCase().includes(keyword);

      let matchesStatus = true;

      switch (statusFilter) {
        case "PRESENT":
          matchesStatus = item.checkInTime && item.checkOutTime;
          break;

        case "WORKING":
          matchesStatus = item.checkInTime && !item.checkOutTime;
          break;

        case "ABSENT":
          matchesStatus = !item.checkInTime;
          break;

        default:
          matchesStatus = true;
      }

      return matchesSearch && matchesStatus;
    });
  }, [attendance, search, statusFilter]);

  const openDetails = (agent) => {
    // Next step we'll call Details API here
    setSelectedAgent(agent);
    setShowModal(true);
  };

  return (
    <>
      <div className="card all-cards mt-10 p-0">
        <div className="card-header bg-white py-6">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="mb-0">Agent Attendance</h5>
            <span className="agentCount">
              Total Agents : <strong>{filteredAttendance.length}</strong>
            </span>
          </div>
        </div>

        <div className="card-body table-responsive p-4">
          <div className="card-body p-0">
            {/* <div className="col-lg-4">
                <Search
                  placeholder="Search by Employee ID or Name"
                  allowClear
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div> */}
            <div className="d-flex justify-content-end">
              <div className="mr-3">
                <Select
                  className="w-130px"
                  value={statusFilter}
                  onChange={setStatusFilter}
                  options={[
                    {
                      value: "ALL",
                      label: "All Status",
                    },
                    {
                      value: "PRESENT",
                      label: "Present",
                    },
                    {
                      value: "WORKING",
                      label: "Working",
                    },
                    {
                      value: "ABSENT",
                      label: "Absent",
                    },
                  ]}
                />
              </div>

              <div>
                <DatePicker
                  value={selectedDate}
                  onChange={setSelectedDate}
                  allowClear={false}
                  disabledDate={(current) => current && current > dayjs().endOf("day")}
                />
              </div>
            </div>

            {loading ? (
              <div className="text-center py-5">
                <Spin size="large" />
              </div>
            ) : (
              <AttendanceTable
                attendance={filteredAttendance}
                onView={openDetails}
                selectedDate={selectedDate}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Attendance;
